module.exports = __webpack_public_path__ + "static/cstoreslider-12-min-93e175e06e4ba502aad980388f216811.jpg";